import lazyLoadView from "@/router/lazyLoadView";
import header from "@/layout/AppHeader";
import footer from "@/layout/AppFooter";

export default [
  {
    path: "/account",
    meta: {
      verifiedOnly: true,
      hideNavOnMobile: true,
      routerKey: "account"
    },
    components: {
      header: header,
      default: () => lazyLoadView(import("@/layout/Account.vue")),
      footer: footer
    },
    beforeEnter: (to, from, next) => {
      to.query.redirectFrom = from.fullPath;
      next();
    },
    children: [
      {
        name: "AccountHome",
        path: "",
        components: {
          default: () => lazyLoadView(import("@/views/Account/Home.vue"))
        }
      },
      {
        name: "AccountRevenue",
        path: "revenue",
        components: {
          default: () => lazyLoadView(import("@/views/Account/Revenue.vue"))
        }
      },
      {
        name: "AccountMembership",
        path: "membership",
        components: {
          default: () => lazyLoadView(import("@/views/Account/Membership.vue"))
        }
      },
      {
        name: "AccountUser",
        path: "user",
        components: {
          default: () => lazyLoadView(import("@/views/Account/User.vue"))
        }
      },
      {
        name: "AccountContact",
        path: "contact",
        components: {
          default: () => lazyLoadView(import("@/views/Account/Contact.vue"))
        }
      }
    ]
  }
];
